import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Some of the most difficult conversations you will have at work
                                                are those where you are going against the majority opinion, and
                                                feel pressured to conform. This tool is about<span
                                                    className="brown brownbold"> how to manage difficult conversations </span>and
                                                will help you to approach and be successful in going against the
                                                majority, and other kinds of difficult conversations that can
                                                hinder you at work.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>INTRODUCTION</div>
                                            <p>Occasionally, you’re bound to have difficult conversations –
                                                telling your partner you crashed their car, perhaps, or dealing
                                                with an underperforming employee. However, when you know how to
                                                manage these conversations, you can dispel some of the tension
                                                you and the other parties may feel.</p>
                                            <div className="border_subtitle">What is ‘difficult’ is different
                                                for everyone, but it’s often:
                                            </div>
                                            <ul className="greenbullet-list people-list-pad">

                                                <li>Giving a performance appraisal to a problem employee</li>
                                                <li>Saying ‘no’ to a colleague or manager</li>
                                                <li>Confronting unreasonable behaviour</li>
                                                <li>Disagreeing with the majority</li>
                                                <li> Admitting to a mistake.</li>
                                            </ul>
                                            <p>While the details of different difficult conversations vary,
                                                there are valuable techniques and tips which can apply to any of
                                                them, because our reasons for avoiding them are often the
                                                same.</p>

                                            <div className="border_subtitle">What is a difficult conversation?
                                            </div>
                                            <div className="paraspace"><p>The examples below can cause
                                                conversations to be difficult, generally by increasing the level
                                                of stress and/or tension in one or both of the parties
                                                involved.</p></div>

                                            <ul className="greenbullet-list  sept">
                                                <li>Fear of rejection</li>
                                                <li>Embarrassment</li>
                                                <li>Feelings of anger</li>
                                                <li>Feelings of injustice.</li>
                                            </ul>

                                            <div className="circle_title">
<span className="heading">
<img src={require('@images/browndot.jpg')} alt=""/></span>
                                                <span
                                                    className="heading">WHY DO WE AVOID DIFFICULT CONVERSATIONS?</span>
                                            </div>
                                            <div className="border_subtitle">Past experience</div>
                                            <p>Memories of a single difficult conversation can affect our
                                                attitude to even the possibility of subsequent ones, on any
                                                subject. Such memories can make us go to great lengths to avoid
                                                confrontation of any kind – or to react with the ferocity of a
                                                cornered rat. No matter which behaviour you recognise in
                                                yourself, you can learn to handle things with elegance and
                                                cool!</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Focus on the positive</div>
                                                <p>Think about the approaches you have taken in the past that
                                                    worked well. After all, a top athlete who competed in the
                                                    long jump wouldn’t spend all his time worrying about his
                                                    proficiency in the 100 metres! No, he would spend his time
                                                    working on the thing he does best – the long jump. Work out
                                                    what your long jump is.</p>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }